/*!
 * loadTasks.js — what is still loading, told to whoever shows it
 * © 2026 Rob Canning — GPLv3
 *
 * The engine says what it is fetching (an audio file, a pool, an impulse
 * response); the score's loader (projectLoadProgressUI.js) shows it while
 * a project opens. On a page without one (Oscilla Live) nobody listens.
 */

let listener = null;

/** The one who shows it: { registered(taskId, label), completed(taskId) }. */
export function onLoadTasks(l) { listener = l; }

export const registerTask = (taskId, label = taskId) => listener?.registered(taskId, label);
export const completeTask = taskId => listener?.completed(taskId);
